import { 
    Box, 
    Button, 
    Chip, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    FormControl, 
    Grid, 
    InputLabel, 
    MenuItem, 
    Select, 
    Stack, 
    Typography, 
    useMediaQuery,
    Container,
    Card,
    CardContent,
    Fade,
    useTheme,
    Divider,
    LinearProgress
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-multi-carousel/lib/styles.css';
import Carousel from 'react-multi-carousel';
import { Base64 } from 'js-base64';
import instId from '../network/instituteId';
import { BASE_URL } from '../network/endpoints';
import Network from '../network/Network';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StarIcon from '@mui/icons-material/Star';
import parse from "html-react-parser";


export const CourseDrips = () => {
    const theme = useTheme();
    const scheduleRef = useRef(null);
    const planRef = useRef(null);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
    const location = useLocation();
    const courseObj = location?.state?.data
    const navigate = useNavigate()
    const queryParam = new URLSearchParams(location.search);
    const campaignId = queryParam.get("campaignId");
    const [selectedTag, setSelectedTag] = useState('');
    const [course, setCourse] = useState([]);
    const [filterCourse, setFilterCourse] = useState([]);
    const [tagsList, setTagsList] = useState([]);
    const [Endpoints, setEndpoints] = useState('');
    const [coursesList, setCoursesList] = useState([]);
    const [courseExpandedDescriptions, setCourseExpandedDescriptions] = useState(false);
    const [fullDes, setFullDes] = useState('');
    const [courseContentList, setCourseContentList] = useState([]);
    const [selectedSceduleList, setSelectedSceduleList] = useState([]);
    const [schedulePlans, setSchedulePlans] = useState([]);
    const [planList, setPlanList] = useState([]);
    const [selectedContentId, setSelectedContentId] = useState({});
    const [selectedPlan, setSelectedPlan] = useState({});
    const [selectedSchedule, setSelectedSchedule] = useState({});
    const [shouldScrollToSchedule, setShouldScrollToSchedule] = useState(false);
    const [shouldScrollToPlan, setShouldScrollToPlan] = useState(false);
    const [loading, setLoading] = useState(true);

    // console.log('courseObj', courseObj);

    useEffect(() => {
        if (shouldScrollToSchedule && schedulePlans?.length > 0 && scheduleRef.current) {
            scheduleRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setShouldScrollToSchedule(false);
        }
    }, [schedulePlans, shouldScrollToSchedule]);

    useEffect(() => {
        if (shouldScrollToPlan && planList?.length > 0 && planRef.current) {
            planRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setShouldScrollToPlan(false);
        }
    }, [planList, shouldScrollToPlan]);

    useEffect(() => {
        window.scrollTo(0, 0);
        const loadData = async () => {
            setLoading(true);
            await Promise.all([getAllCourses(), getInstituteDetail()]);
            setLoading(false);
        };
        loadData();
    }, []);

    useEffect(() => {
        if (courseObj?.id) {
            getCourseSchedule(courseObj?.id, 0)
        }
    }, [courseObj]);

    useEffect(() => {
        if (courseContentList?.length > 0) {
            setSelectedSchedule(courseContentList[0])
            getSelectedSchedule(courseObj?.id, courseContentList[0]?.id, 'first')
        }
    }, [courseContentList]);



    const getAllCourses = async () => {
        const response = await Network.fetchCourses(instId);
        const course = response?.courses;
        const filterCourses = course?.filter((item) => item?.active === true);
        setCoursesList(filterCourses);
    };

    const getInstituteDetail = async () => {
        try {
            let requestOptions = {
                // headers: { "X-Auth": token },
                withCredentials: false,
            };
            const response = await axios.get(
                BASE_URL + "/getMetaData/fetch-institute/" + instId,
                requestOptions
            );
            if (response?.data?.errorCode === 0) {
                setEndpoints(response?.data?.instituteTechSetting?.mediaUrl)
                // Endpoints = response?.data?.instituteTechSetting?.mediaUrl
            };
        } catch (error) {
            console.log(error);
        }
    };

    const getCourseSchedule = async (courseId, contentId) => {
        try {
            const response = await Network.fetchCheduleApi(courseId, contentId);
            if (contentId === 0) {
                // First call, store course content list
                setCourseContentList(response?.contentList || []);
            }
        } catch (error) {
            console.error("Error fetching course schedule:", error);
        }
    };

    const getSelectedSchedule = async (courseId, contentId, value) => {
        try {
            const response = await Network.fetchCheduleApi(courseId, contentId);
            if (value === "first") {
                setSelectedSceduleList(response?.contentList || []);
            }
            if (value === "second") {
                setSchedulePlans(response?.contentList || []);
            }
            if (value === "third") {
                setPlanList(response?.contentList || []);
            }

        } catch (error) {
            console.error("Error fetching course schedule:", error);
        }
    };

    const handleContentClick = (contentId) => {
        setPlanList([]);
        setSelectedContentId(contentId);
        getSelectedSchedule(courseObj?.id, contentId?.id, 'second');

        setShouldScrollToSchedule(true);
    };

    const handleSelectPlan = (contentId) => {

        if ((selectedContentId?.title === "Full Length Test Series" && (courseObj?.title === "CA Final" || courseObj?.title === "CA Inter")) || (selectedContentId?.title === "Portion WiseTest Series" && courseObj?.title === "CA Final")) {

            let data = Base64.encode(JSON.stringify({
                courseObj: courseObj, selectedPlanData:
                    "", selectedSchedule: selectedSchedule, selectScheduleContent: selectedContentId, basicPlan: contentId
            }), true)
            navigate('/test-series?data=' + data);
        } else if (selectedContentId?.title === "Full Length Test Series" && courseObj?.title === "CA Foundation") {
            let data = Base64.encode(JSON.stringify({ courseObj: courseObj, selectedPlanData: contentId, selectedSchedule: selectedSchedule, selectScheduleContent: selectedContentId, basicPlan: contentId }), true)
            navigate('/foundation-test-series?data=' + data)

        } else {
            setSelectedPlan(contentId);
            getSelectedSchedule(courseObj?.id, contentId?.id, 'third');
            setShouldScrollToPlan(true);
        }

    };

    const toggleExpandDescription = (des) => {
        setFullDes(des)
        setCourseExpandedDescriptions(true);
    };

    const truncateDescription = (description) => {
        // Replace &nbsp; and other HTML entities with plain text equivalents
        const decodedDescription = description
            ?.replace(/&nbsp;/g, ' ')
            ?.replace(/&amp;/g, '&') // Example for handling other entities, can add more if needed
            ?.replace(/&lt;/g, '<')
            ?.replace(/&gt;/g, '>')
            ?.replace(/&quot;/g, '"')
            ?.replace(/&#39;/g, "'");

        // Strip any remaining HTML tags
        const strippedDescription = decodedDescription
            ?.replace(/<[^>]*>/g, ' ') // Remove HTML tags
            .split(/\s+/)
            .slice(0, 10) // Get first 10 words
            .join(' ');

        return strippedDescription;
    };



    const handleTestDetail = (item) => {
        if (courseObj?.title === "CA Foundation") {
            let data = Base64.encode(JSON.stringify({ courseObj: courseObj, selectedPlanData: item, selectedSchedule: selectedSchedule, selectScheduleContent: selectedContentId, basicPlan: selectedPlan }), true)
            navigate('/foundation-test-series?data=' + data)
        } else {
            let data = Base64.encode(JSON.stringify({ courseObj: courseObj, selectedPlanData: item, selectedSchedule: selectedSchedule, selectScheduleContent: selectedContentId, basicPlan: selectedPlan }), true)
            navigate('/test-series?data=' + data)
        }

    }    


    return (
        <Box
            id="testseries"
            sx={{
                // minHeight: '100vh',
                background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 25%, #cbd5e1 50%, #94a3b8 100%)',
                position: 'relative',
                overflow: 'hidden',
                pt: { xs: 8, md: 8 },
                // pb: { xs: 4, md: 4 },
                // px: { xs: 2, sm: 3, md: 4 },
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: `
                        radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.08) 0%, transparent 50%),
                        radial-gradient(circle at 80% 70%, rgba(99, 102, 241, 0.06) 0%, transparent 50%),
                        radial-gradient(circle at 40% 80%, rgba(168, 85, 247, 0.05) 0%, transparent 40%),
                        radial-gradient(circle at 60% 20%, rgba(139, 92, 246, 0.04) 0%, transparent 40%)
                    `,
                    pointerEvents: 'none',
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(45deg, rgba(255,255,255,0.3) 0%, transparent 100%)',
                    pointerEvents: 'none',
                },
            }}
        >
            <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
                {/* Floating Particles */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: '10%',
                        left: '10%',
                        width: '6px',
                        height: '6px',
                        background: 'linear-gradient(135deg, #3b82f6, #6366f1)',
                        borderRadius: '50%',
                        opacity: 0.6,
                        animation: 'float1 6s ease-in-out infinite',
                        '@keyframes float1': {
                            '0%, 100%': { transform: 'translateY(0px) translateX(0px)' },
                            '25%': { transform: 'translateY(-15px) translateX(8px)' },
                            '50%': { transform: 'translateY(-8px) translateX(-10px)' },
                            '75%': { transform: 'translateY(-20px) translateX(4px)' },
                        },
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        top: '20%',
                        right: '15%',
                        width: '8px',
                        height: '8px',
                        background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                        borderRadius: '50%',
                        opacity: 0.5,
                        animation: 'float2 8s ease-in-out infinite',
                        '@keyframes float2': {
                            '0%, 100%': { transform: 'translateY(0px) translateX(0px) scale(1)' },
                            '33%': { transform: 'translateY(-20px) translateX(-8px) scale(1.1)' },
                            '66%': { transform: 'translateY(-4px) translateX(15px) scale(0.9)' },
                        },
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: '25%',
                        left: '5%',
                        width: '5px',
                        height: '5px',
                        background: 'linear-gradient(135deg, #8b5cf6, #a855f7)',
                        borderRadius: '50%',
                        opacity: 0.4,
                        animation: 'float3 7s ease-in-out infinite',
                        '@keyframes float3': {
                            '0%, 100%': { transform: 'translateY(0px) rotate(0deg)' },
                            '50%': { transform: 'translateY(-30px) rotate(180deg)' },
                        },
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: '15%',
                        right: '8%',
                        width: '7px',
                        height: '7px',
                        background: 'linear-gradient(135deg, #a855f7, #8b5cf6)',
                        borderRadius: '50%',
                        opacity: 0.6,
                        animation: 'float4 9s ease-in-out infinite',
                        '@keyframes float4': {
                            '0%, 100%': { transform: 'translateY(0px) translateX(0px) scale(1)' },
                            '25%': { transform: 'translateY(-12px) translateX(-15px) scale(1.2)' },
                            '50%': { transform: 'translateY(-25px) translateX(8px) scale(0.8)' },
                            '75%': { transform: 'translateY(-15px) translateX(12px) scale(1.05)' },
                        },
                    }}
                />
                {/* Hero Section */}
                <Fade in timeout={1000}>
                    <Card
                        sx={{
                            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.9) 50%, rgba(241, 245, 249, 0.85) 100%)',
                            backdropFilter: 'blur(20px)',
                            border: '1px solid rgba(255, 255, 255, 0.8)',
                            borderRadius: 6,
                            p: { xs: 4, md: 6 },
                            mb: 6,
                            boxShadow: '0 20px 40px rgba(0,0,0,0.08), 0 8px 25px rgba(59, 130, 246, 0.1)',
                            position: 'relative',
                            overflow: 'hidden',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: '3px',
                                background: 'linear-gradient(90deg, transparent 0%, rgba(59, 130, 246, 0.6) 25%, rgba(99, 102, 241, 0.6) 50%, rgba(139, 92, 246, 0.6) 75%, transparent 100%)',
                                animation: 'shimmer 3s ease-in-out infinite',
                                '@keyframes shimmer': {
                                    '0%, 100%': { opacity: 0.6 },
                                    '50%': { opacity: 1 },
                                },
                            },
                        }}
                    >
                        <Grid container spacing={4} alignItems="center">
                            <Grid item xs={12} md={8}>
                                <Box mb={3}>
                                    <Typography
                                        variant="h3"
                                        sx={{
                                            fontSize: { xs: '2.5rem', sm: '3.2rem', md: '4rem' },
                                            fontWeight: 900,
                                            background: 'linear-gradient(135deg, #1e293b 0%, #334155 30%, #475569 60%, #64748b 100%)',
                                            backgroundClip: 'text',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            mb: 4,
                                            lineHeight: 1.1,
                                            textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                            position: 'relative',
                                            '&::after': {
                                                content: '""',
                                                position: 'absolute',
                                                bottom: -10,
                                                left: 0,
                                                width: '60px',
                                                height: '4px',
                                                background: 'linear-gradient(90deg, #3b82f6, #6366f1, #8b5cf6)',
                                                borderRadius: 2,
                                                animation: 'glow 2s ease-in-out infinite alternate',
                                                '@keyframes glow': {
                                                    '0%': { boxShadow: '0 0 5px rgba(59, 130, 246, 0.4)' },
                                                    '100%': { boxShadow: '0 0 15px rgba(59, 130, 246, 0.6)' },
                                                },
                                            },
                                        }}
                                    >
                                        Let's Personalize Your
                                        <br />
                                        <Box
                                            component="span"
                                            sx={{
                                                background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 25%, #8b5cf6 50%, #a855f7 75%, #6366f1 100%)',
                                                backgroundClip: 'text',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                                backgroundSize: '200% 200%',
                                                animation: 'gradientShift 4s ease-in-out infinite',
                                                '@keyframes gradientShift': {
                                                    '0%, 100%': { backgroundPosition: '0% 50%' },
                                                    '50%': { backgroundPosition: '100% 50%' },
                                                },
                                            }}
                                        >
                                            {courseObj?.title} Test Series
                                        </Box>
                                    </Typography>
                                </Box>
                                <Typography
                                    sx={{
                                        color: 'rgba(30, 41, 59, 0.85)',
                                        fontSize: { xs: '1.2rem', md: '1.4rem' },
                                        lineHeight: 1.7,
                                        fontWeight: 400,
                                        textShadow: '0 1px 2px rgba(0,0,0,0.05)',
                                    }}
                                >
                                    Personalizing your {courseObj?.title} Test Series is simple and efficient. Start by selecting the Test Series Portion Type, followed by choosing the Test Series Plan that suits your needs. Next, determine the Level of Premiumness for added benefits. Finally, generate your Customized Test Series Plan and get started with your preparation!
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={4} textAlign="center">
                                <Box
                                    sx={{
                                        background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(99, 102, 241, 0.08) 30%, rgba(139, 92, 246, 0.06) 60%, rgba(168, 85, 247, 0.08) 100%)',
                                        borderRadius: 5,
                                        p: 5,
                                        border: '1px solid rgba(59, 130, 246, 0.2)',
                                        backdropFilter: 'blur(10px)',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        boxShadow: '0 10px 25px rgba(59, 130, 246, 0.1)',
                                        '&::before': {
                                            content: '""',
                                            position: 'absolute',
                                            top: -1,
                                            left: -1,
                                            right: -1,
                                            bottom: -1,
                                            background: 'linear-gradient(135deg, #3b82f6, #6366f1, #8b5cf6)',
                                            borderRadius: 5,
                                            zIndex: -1,
                                            opacity: 0.1,
                                            animation: 'borderGlow 3s ease-in-out infinite',
                                            '@keyframes borderGlow': {
                                                '0%, 100%': { opacity: 0.1 },
                                                '50%': { opacity: 0.2 },
                                            },
                                        },
                                    }}
                                >
                                    <StarIcon sx={{ 
                                        fontSize: 64, 
                                        background: 'linear-gradient(135deg, #3b82f6, #6366f1, #8b5cf6)',
                                        backgroundClip: 'text',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        mb: 3,
                                        filter: 'drop-shadow(0 4px 8px rgba(59, 130, 246, 0.2))',
                                        animation: 'pulse 2s ease-in-out infinite',
                                        '@keyframes pulse': {
                                            '0%, 100%': { transform: 'scale(1)' },
                                            '50%': { transform: 'scale(1.05)' },
                                        },
                                    }} />
                                    <Typography
                                        sx={{
                                            color: 'rgba(30, 41, 59, 0.9)',
                                            fontWeight: 700,
                                            fontSize: '1.4rem',
                                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                        }}
                                    >
                                        Premium Experience
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: 'rgba(30, 41, 59, 0.6)',
                                            fontSize: '1.1rem',
                                            mt: 1,
                                        }}
                                    >
                                        Tailored for Success
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Card>
                </Fade>

                {/* Step 1: Test Series Portion Type */}
                <Fade in timeout={1200}>
                    <Card
                        sx={{
                            background: 'linear-gradient(135deg, rgba(219, 234, 254, 0.6) 0%, rgba(241, 245, 249, 0.8) 100%)',
                            backdropFilter: 'blur(20px)',
                            border: '1px solid rgba(59, 130, 246, 0.15)',
                            borderRadius: 6,
                            p: { xs: 4, md: 6 },
                            mb: 6,
                            boxShadow: '0 20px 40px rgba(59, 130, 246, 0.08), 0 8px 25px rgba(0,0,0,0.05)',
                            position: 'relative',
                            overflow: 'hidden',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: '3px',
                                background: 'linear-gradient(90deg, transparent 0%, rgba(59, 130, 246, 0.7) 25%, rgba(99, 102, 241, 0.7) 50%, rgba(139, 92, 246, 0.7) 75%, transparent 100%)',
                                animation: 'slideShimmer 3s ease-in-out infinite',
                                '@keyframes slideShimmer': {
                                    '0%': { transform: 'translateX(-100%)' },
                                    '100%': { transform: 'translateX(100%)' },
                                },
                            },
                        }}
                    >
                        <Box display="flex" alignItems="center" mb={4}>
                            <Box
                                sx={{
                                    background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 50%, #8b5cf6 100%)',
                                    borderRadius: '50%',
                                    width: 56,
                                    height: 56,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 3,
                                    boxShadow: '0 8px 20px rgba(59, 130, 246, 0.25), inset 0 1px 0 rgba(255,255,255,0.2)',
                                    border: '2px solid rgba(255,255,255,0.9)',
                                    position: 'relative',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: -3,
                                        left: -3,
                                        right: -3,
                                        bottom: -3,
                                        background: 'linear-gradient(135deg, #3b82f6, #6366f1, #8b5cf6)',
                                        borderRadius: '50%',
                                        zIndex: -1,
                                        opacity: 0.2,
                                        animation: 'stepGlow 2s ease-in-out infinite',
                                        '@keyframes stepGlow': {
                                            '0%, 100%': { opacity: 0.2 },
                                            '50%': { opacity: 0.4 },
                                        },
                                    },
                                }}
                            >
                                <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '1.4rem' }}>
                                    1
                                </Typography>
                            </Box>
                            <Box>
                                <Typography
                                    sx={{
                                        color: 'rgba(30, 41, 59, 0.9)',
                                        fontSize: { xs: '1.3rem', md: '1.5rem' },
                                        fontWeight: 700,
                                        display: 'flex',
                                        alignItems: 'center',
                                        textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    Select Test Series Portion Type
                                    <ArrowForwardIcon sx={{ ml: 2, fontSize: 28, color: '#3b82f6' }} />
                                </Typography>
                                <Typography
                                    sx={{
                                        color: 'rgba(30, 41, 59, 0.6)',
                                        fontSize: '1.1rem',
                                        mt: 0.5,
                                    }}
                                >
                                    Choose your preferred test series format
                                </Typography>
                            </Box>
                        </Box>

                        <Grid container spacing={3}>
                            {selectedSceduleList?.map((content) => (
                                <Grid item key={content.id} xs={12} sm={6} md={3}>
                                    <Button
                                        fullWidth
                                        onClick={() => handleContentClick(content)}
                                        sx={{
                                            background: content.id === selectedContentId?.id 
                                                ? 'linear-gradient(135deg, #2563eb 0%, #3b82f6 50%, #6366f1 100%)'
                                                : 'linear-gradient(135deg, #3b82f6 0%, #6366f1 50%, #8b5cf6 100%)',
                                            color: 'white',
                                            py: 2,
                                            px: 4,
                                            borderRadius: 5,
                                            fontSize: { xs: '1.1rem', md: '1.3rem' },
                                            fontWeight: 700,
                                            textTransform: 'none',
                                            border: content.id === selectedContentId?.id 
                                                ? '2px solid rgba(255,255,255,0.9)' 
                                                : '1px solid rgba(255,255,255,0.7)',
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            boxShadow: content.id === selectedContentId?.id 
                                                ? '0 12px 30px rgba(59, 130, 246, 0.25)' 
                                                : '0 8px 20px rgba(59, 130, 246, 0.15)',
                                            '&::before': {
                                                content: '""',
                                                position: 'absolute',
                                                top: 0,
                                                left: '-100%',
                                                width: '100%',
                                                height: '100%',
                                                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                                                transition: 'left 0.6s',
                                            },
                                            '&::after': content.id === selectedContentId?.id ? {
                                                content: '""',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                height: '2px',
                                                background: 'linear-gradient(90deg, #8b5cf6, #a855f7, #6366f1)',
                                                animation: 'selectedGlow 2s ease-in-out infinite',
                                                '@keyframes selectedGlow': {
                                                    '0%, 100%': { opacity: 0.7 },
                                                    '50%': { opacity: 1 },
                                                },
                                            } : {},
                                            '&:hover': {
                                                transform: 'translateY(-4px) scale(1.02)',
                                                boxShadow: '0 16px 35px rgba(59, 130, 246, 0.3)',
                                                background: 'linear-gradient(135deg, #1e40af 0%, #2563eb 50%, #3b82f6 100%)',
                                                '&::before': {
                                                    left: '100%',
                                                },
                                            },
                                        }}
                                    >
                                        {content.id === selectedContentId?.id && (
                                            <CheckCircleIcon sx={{ mr: 2, fontSize: 20, filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }} />
                                        )}
                                        {content.title}
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>
                    </Card>
                </Fade>

                <Box ref={scheduleRef}></Box>

                {/* Step 2: Test Series Plan Type */}
                {schedulePlans?.length > 0 && (
                    <Fade in timeout={1400}>
                        <Card
                            sx={{
                                background: 'linear-gradient(135deg, rgba(224, 231, 255, 0.6) 0%, rgba(248, 250, 252, 0.8) 100%)',
                                backdropFilter: 'blur(20px)',
                                border: '1px solid rgba(99, 102, 241, 0.15)',
                                borderRadius: 6,
                                p: { xs: 4, md: 6 },
                                mb: 6,
                                boxShadow: '0 20px 40px rgba(99, 102, 241, 0.08), 0 8px 25px rgba(0,0,0,0.05)',
                                position: 'relative',
                                overflow: 'hidden',
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: '3px',
                                    background: 'linear-gradient(90deg, transparent 0%, rgba(99, 102, 241, 0.7) 25%, rgba(139, 92, 246, 0.7) 50%, rgba(168, 85, 247, 0.7) 75%, transparent 100%)',
                                    animation: 'slideShimmer 3s ease-in-out infinite',
                                },
                            }}
                        >
                            <Box display="flex" alignItems="center" mb={4}>
                                <Box
                                    sx={{
                                        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)',
                                        borderRadius: '50%',
                                        width: 56,
                                        height: 56,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 3,
                                        boxShadow: '0 8px 20px rgba(99, 102, 241, 0.25), inset 0 1px 0 rgba(255,255,255,0.2)',
                                        border: '2px solid rgba(255,255,255,0.9)',
                                        position: 'relative',
                                        '&::before': {
                                            content: '""',
                                            position: 'absolute',
                                            top: -3,
                                            left: -3,
                                            right: -3,
                                            bottom: -3,
                                            background: 'linear-gradient(135deg, #6366f1, #8b5cf6, #a855f7)',
                                            borderRadius: '50%',
                                            zIndex: -1,
                                            opacity: 0.2,
                                            animation: 'stepGlow 2s ease-in-out infinite',
                                        },
                                    }}
                                >
                                    <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '1.4rem' }}>
                                        2
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography
                                        sx={{
                                            color: 'rgba(30, 41, 59, 0.9)',
                                            fontSize: { xs: '1.3rem', md: '1.5rem' },
                                            fontWeight: 700,
                                            display: 'flex',
                                            alignItems: 'center',
                                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                        }}
                                    >
                                        Select Test Series Plan Type
                                        <ArrowForwardIcon sx={{ ml: 2, fontSize: 28, color: '#6366f1' }} />
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: 'rgba(30, 41, 59, 0.6)',
                                            fontSize: '1.1rem',
                                            mt: 0.5,
                                        }}
                                    >
                                        Pick the plan that matches your preparation goals
                                    </Typography>
                                </Box>
                            </Box>

                            <Grid container spacing={4}>
                                {schedulePlans?.map((item, i) => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                                        <Card
                                            sx={{
                                                background: item.id === selectedPlan?.id 
                                                    ? 'linear-gradient(135deg, rgba(196, 181, 253, 0.4) 0%, rgba(221, 214, 254, 0.3) 50%, rgba(233, 213, 255, 0.25) 100%)'
                                                    : 'linear-gradient(135deg, rgba(240, 249, 255, 0.8) 0%, rgba(248, 250, 252, 0.7) 100%)',
                                                backdropFilter: 'blur(15px)',
                                                border: item.id === selectedPlan?.id 
                                                    ? '2px solid rgba(99, 102, 241, 0.3)'
                                                    : '1px solid rgba(100, 116, 139, 0.2)',
                                                borderRadius: 6,
                                                position: 'relative',
                                                height: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                overflow: 'hidden',
                                                boxShadow: item.id === selectedPlan?.id 
                                                    ? '0 16px 35px rgba(99, 102, 241, 0.2)' 
                                                    : '0 8px 20px rgba(0,0,0,0.08)',
                                                '&::before': item.id === selectedPlan?.id ? {
                                                    content: '""',
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    height: '3px',
                                                    background: 'linear-gradient(90deg, #6366f1, #8b5cf6, #a855f7)',
                                                    animation: 'selectedShimmer 3s linear infinite',
                                                    '@keyframes selectedShimmer': {
                                                        '0%': { transform: 'translateX(-100%)' },
                                                        '100%': { transform: 'translateX(100%)' },
                                                    },
                                                } : {},
                                                '&:hover': {
                                                    transform: 'translateY(-8px) scale(1.02)',
                                                    boxShadow: '0 20px 40px rgba(99, 102, 241, 0.15)',
                                                    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.9) 100%)',
                                                    border: '1px solid rgba(99, 102, 241, 0.25)',
                                                },
                                            }}
                                        >
                                            <CardContent sx={{ flexGrow: 1, p: 4, pb: 2 }}>
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        fontWeight: 700,
                                                        color: 'rgba(30, 41, 59, 0.9)',
                                                        mb: 3,
                                                        fontSize: { xs: '1.3rem', md: '1.5rem' },
                                                        textAlign: 'center',
                                                        textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                                    }}
                                                >
                                                    {item?.title}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        color: 'rgba(30, 41, 59, 0.7)',
                                                        fontSize: { xs: '1rem', md: '1.1rem' },
                                                        lineHeight: 1.6,
                                                        '& p': { margin: 0, marginBottom: 1, color: 'rgba(30, 41, 59, 0.7)' },
                                                        '& ul': { paddingLeft: 2 },
                                                        '& li': { marginBottom: 0.5, color: 'rgba(30, 41, 59, 0.7)' },
                                                    }}
                                                >
                                                    {item?.description?.description ? parse(item?.description?.description) : ""}
                                                </Box>
                                            </CardContent>
                                            <Box sx={{ p: 4, pt: 0 }}>
                                                <Button
                                                    fullWidth
                                                    onClick={() => handleSelectPlan(item)}
                                                    sx={{
                                                        background: item.id === selectedPlan?.id 
                                                            ? 'linear-gradient(135deg, #5b21b6 0%, #7c3aed 50%, #8b5cf6 100%)'
                                                            : 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)',
                                                        color: 'white',
                                                        py: 2,
                                                        borderRadius: 4,
                                                        fontSize: { xs: '1rem', md: '1.15rem' },
                                                        fontWeight: 700,
                                                        textTransform: 'none',
                                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                        border: item.id === selectedPlan?.id ? '2px solid rgba(255,255,255,0.9)' : '1px solid rgba(255,255,255,0.7)',
                                                        position: 'relative',
                                                        overflow: 'hidden',
                                                        boxShadow: item.id === selectedPlan?.id 
                                                            ? '0 10px 25px rgba(99, 102, 241, 0.3)' 
                                                            : '0 6px 15px rgba(99, 102, 241, 0.2)',
                                                        '&::before': {
                                                            content: '""',
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: '-100%',
                                                            width: '100%',
                                                            height: '100%',
                                                            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                                                            transition: 'left 0.6s',
                                                        },
                                                        '&:hover': {
                                                            background: 'linear-gradient(135deg, #4c1d95 0%, #6d28d9 50%, #7c3aed 100%)',
                                                            transform: 'translateY(-2px) scale(1.02)',
                                                            boxShadow: '0 12px 30px rgba(99, 102, 241, 0.4)',
                                                            '&::before': {
                                                                left: '100%',
                                                            },
                                                        },
                                                    }}
                                                >
                                                    {item.id === selectedPlan?.id ? (
                                                        <>
                                                            <CheckCircleIcon sx={{ mr: 1, fontSize: 18, filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }} />
                                                            Selected
                                                        </>
                                                    ) : (
                                                        'Select Plan'
                                                    )}
                                                </Button>
                                            </Box>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Card>
                    </Fade>
                )}

                <Box ref={planRef}></Box>

                {/* Step 3: Programme Level Type */}
                {planList?.length > 0 && (
                    <Fade in timeout={1600}>
                        <Card
                            sx={{
                                background: 'linear-gradient(135deg, rgba(237, 233, 254, 0.6) 0%, rgba(248, 250, 252, 0.8) 100%)',
                                backdropFilter: 'blur(20px)',
                                border: '1px solid rgba(139, 92, 246, 0.15)',
                                borderRadius: 6,
                                p: { xs: 4, md: 6 },
                                mb: 6,
                                boxShadow: '0 20px 40px rgba(139, 92, 246, 0.08), 0 8px 25px rgba(0,0,0,0.05)',
                                position: 'relative',
                                overflow: 'hidden',
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: '3px',
                                    background: 'linear-gradient(90deg, transparent 0%, rgba(139, 92, 246, 0.7) 25%, rgba(168, 85, 247, 0.7) 50%, rgba(147, 51, 234, 0.7) 75%, transparent 100%)',
                                    animation: 'slideShimmer 3s ease-in-out infinite',
                                },
                            }}
                        >
                            <Box display="flex" alignItems="center" mb={4}>
                                <Box
                                    sx={{
                                        background: 'linear-gradient(135deg, #8b5cf6 0%, #a855f7 50%, #9333ea 100%)',
                                        borderRadius: '50%',
                                        width: 56,
                                        height: 56,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 3,
                                        boxShadow: '0 8px 20px rgba(139, 92, 246, 0.25), inset 0 1px 0 rgba(255,255,255,0.2)',
                                        border: '2px solid rgba(255,255,255,0.9)',
                                        position: 'relative',
                                        '&::before': {
                                            content: '""',
                                            position: 'absolute',
                                            top: -3,
                                            left: -3,
                                            right: -3,
                                            bottom: -3,
                                            background: 'linear-gradient(135deg, #8b5cf6, #a855f7, #9333ea)',
                                            borderRadius: '50%',
                                            zIndex: -1,
                                            opacity: 0.2,
                                            animation: 'stepGlow 2s ease-in-out infinite',
                                        },
                                    }}
                                >
                                    <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '1.4rem' }}>
                                        3
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography
                                        sx={{
                                            color: 'rgba(30, 41, 59, 0.9)',
                                            fontSize: { xs: '1.3rem', md: '1.5rem' },
                                            fontWeight: 700,
                                            display: 'flex',
                                            alignItems: 'center',
                                            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                        }}
                                    >
                                        Select Programme Level Type
                                        <ArrowForwardIcon sx={{ ml: 2, fontSize: 28, color: '#8b5cf6' }} />
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: 'rgba(30, 41, 59, 0.6)',
                                            fontSize: '1.1rem',
                                            mt: 0.5,
                                        }}
                                    >
                                        Choose your premium level and features
                                    </Typography>
                                </Box>
                            </Box>

                            <Grid container spacing={4}>
                                {planList?.map((item, i) => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                                        <Card
                                            sx={{
                                                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.8) 100%)',
                                                backdropFilter: 'blur(15px)',
                                                border: '1px solid rgba(100, 116, 139, 0.2)',
                                                borderRadius: 6,
                                                position: 'relative',
                                                height: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                overflow: 'hidden',
                                                boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
                                                '&:hover': {
                                                    transform: 'translateY(-8px) scale(1.02)',
                                                    boxShadow: '0 20px 40px rgba(139, 92, 246, 0.15)',
                                                    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.9) 100%)',
                                                    border: '1px solid rgba(139, 92, 246, 0.25)',
                                                },
                                            }}
                                        >
                                            <CardContent sx={{ flexGrow: 1, p: 4, pb: 2 }}>
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        fontWeight: 700,
                                                        color: 'rgba(30, 41, 59, 0.9)',
                                                        mb: 3,
                                                        fontSize: { xs: '1.3rem', md: '1.5rem' },
                                                        textAlign: 'center',
                                                        textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                                    }}
                                                >
                                                    {item?.title}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        color: 'rgba(30, 41, 59, 0.7)',
                                                        fontSize: { xs: '1rem', md: '1.1rem' },
                                                        lineHeight: 1.6,
                                                        '& p': { margin: 0, marginBottom: 1, color: 'rgba(30, 41, 59, 0.7)' },
                                                        '& ul': { paddingLeft: 2 },
                                                        '& li': { marginBottom: 0.5, color: 'rgba(30, 41, 59, 0.7)' },
                                                    }}
                                                >
                                                    {item?.description?.description ? parse(item?.description?.description) : ""}
                                                </Box>
                                            </CardContent>
                                            <Box sx={{ p: 4, pt: 0 }}>
                                                <Button
                                                    fullWidth
                                                    onClick={() => handleTestDetail(item)}
                                                    sx={{
                                                        background: 'linear-gradient(135deg, #8b5cf6 0%, #a855f7 50%, #9333ea 100%)',
                                                        color: 'white',
                                                        py: 2,
                                                        borderRadius: 4,
                                                        fontSize: { xs: '1rem', md: '1.15rem' },
                                                        fontWeight: 700,
                                                        textTransform: 'none',
                                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                        border: '1px solid rgba(255,255,255,0.7)',
                                                        position: 'relative',
                                                        overflow: 'hidden',
                                                        boxShadow: '0 6px 15px rgba(139, 92, 246, 0.25)',
                                                        '&::before': {
                                                            content: '""',
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: '-100%',
                                                            width: '100%',
                                                            height: '100%',
                                                            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                                                            transition: 'left 0.6s',
                                                        },
                                                        '&:hover': {
                                                            background: 'linear-gradient(135deg, #7c3aed 0%, #9333ea 50%, #8b5cf6 100%)',
                                                            transform: 'translateY(-2px) scale(1.02)',
                                                            boxShadow: '0 10px 25px rgba(139, 92, 246, 0.4)',
                                                            '&::before': {
                                                                left: '100%',
                                                            },
                                                        },
                                                    }}
                                                >
                                                    Select Programme
                                                </Button>
                                            </Box>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Card>
                    </Fade>
                )}

                {/* Loading State */}
                {loading && (
                    <Fade in timeout={800}>
                        <Card
                            sx={{
                                background: 'linear-gradient(135deg, rgba(253, 246, 178, 0.4) 0%, rgba(254, 249, 195, 0.6) 100%)',
                                backdropFilter: 'blur(20px)',
                                border: '1px solid rgba(251, 191, 36, 0.2)',
                                borderRadius: 5,
                                p: 6,
                                textAlign: 'center',
                                boxShadow: '0 20px 40px rgba(251, 191, 36, 0.08)',
                            }}
                        >
                            <Box
                                sx={{
                                    width: 80,
                                    height: 80,
                                    border: '4px solid rgba(100, 116, 139, 0.2)',
                                    borderTop: '4px solid #3b82f6',
                                    borderRadius: '50%',
                                    animation: 'spin 1.5s linear infinite',
                                    mx: 'auto',
                                    mb: 3,
                                    position: 'relative',
                                    '@keyframes spin': {
                                        '0%': { transform: 'rotate(0deg)' },
                                        '100%': { transform: 'rotate(360deg)' },
                                    },
                                }}
                            />
                            <Typography 
                                sx={{ 
                                    color: 'rgba(30, 41, 59, 0.9)',
                                    fontSize: '1.3rem',
                                    fontWeight: 600,
                                    mb: 1,
                                }}
                            >
                                Loading your personalized test series...
                            </Typography>
                            <Typography 
                                sx={{ 
                                    color: 'rgba(30, 41, 59, 0.6)',
                                    fontSize: '1.1rem',
                                }}
                            >
                                Please wait while we prepare your customized experience
                            </Typography>
                        </Card>
                    </Fade>
                )}
            </Container>

            {/* Enhanced Dialog */}
            <Dialog 
                open={courseExpandedDescriptions} 
                onClose={() => setCourseExpandedDescriptions(false)}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.95) 100%)',
                        backdropFilter: 'blur(20px)',
                        border: '1px solid rgba(100, 116, 139, 0.2)',
                        borderRadius: 4,
                        boxShadow: '0 25px 50px rgba(0,0,0,0.15)',
                    }
                }}
                BackdropProps={{
                    sx: {
                        backgroundColor: 'rgba(0,0,0,0.4)',
                        backdropFilter: 'blur(3px)',
                    }
                }}
            >
                <DialogContent 
                    dividers 
                    sx={{ 
                        color: 'rgba(30, 41, 59, 0.9)',
                        borderColor: 'rgba(100, 116, 139, 0.2)',
                        p: 4,
                        fontSize: '1.1rem',
                        '& p': { marginBottom: 2, fontSize: '1.1rem' },
                        '& ul': { paddingLeft: 3 },
                        '& li': { marginBottom: 1, fontSize: '1rem' },
                    }}
                >
                    <Typography variant='body1' sx={{ lineHeight: 1.7 }}>
                        {parse(fullDes)}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ p: 4, backgroundColor: 'rgba(248, 250, 252, 0.5)' }}>
                    <Button 
                        onClick={() => setCourseExpandedDescriptions(false)}
                        sx={{
                            background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 50%, #8b5cf6 100%)',
                            color: 'white',
                            px: 6,
                            py: 1.5,
                            borderRadius: 3,
                            fontSize: '1.1rem',
                            fontWeight: 600,
                            textTransform: 'none',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 50%, #7c3aed 100%)',
                                transform: 'translateY(-1px)',
                                boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)',
                            }
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};
